// Shared Argyle configuration for resources and UI copy.
// Mirrors plaidConfig.ts so either provider can be swapped in via ProviderToggle.

export type ArgyleWorkflowType = 'bank' | 'payroll';

export const ARGYLE_BANK_PENDING_HINT_PREFIX = 'argyle_bank_return_pending_';
export const ARGYLE_BANK_PENDING_HINT_TTL_MS = 120_000;

export const argyleResources = {
  bank: {
    linkTokenResource: 'argyleBankIncomeLinkToken',
    linkSuccessResource: null,
    linkFailResource: 'argyleBankFailed',
    accountRemovedResource: null,
    notifyLaunch: 'Connecting...',
    notifySuccess: 'Bank verification is processing. Updates will appear shortly.',
    notifyError:
      'Something went wrong while trying to connect to your bank. Please try again later.',
  },
  payroll: {
    linkTokenResource: 'argylePayrollIncomeLinkToken',
    linkSuccessResource: 'argylePayrollPending',
    linkFailResource: null,
    accountRemovedResource: 'argylePayrollAccountRemoved',
    notifyLaunch: 'Connecting...',
    notifySuccess: 'Payroll income is processing. Updates will appear shortly.',
    notifyError:
      'Something went wrong while trying to connect to your payroll provider. Please try again later.',
  },
} as const;

export const argyleCopy = {
  bank: {
    actionDescription:
      'You can verify your income by securely connecting to your bank. If you continue, you will be redirected to securely link your bank account. Docuverus never sees nor stores your bank login information.',
    actionWarning:
      'This action cannot be undone and may increase or decrease your average monthly net income calculation. You can upload payroll or bank documents instead, and you can still add documents after connecting.',
    actionRelinkWarning:
      'Note: Re-linking the same institution replaces its current income data with new deposit data.',
  },
  payroll: {
    actionDescription:
      "You can verify your income by securely connecting to your payroll provider. If you continue, you will be redirected to securely link to your employer's payroll system. Docuverus never sees nor stores your payroll login information.",
    actionWarning:
      'This action cannot be undone and may increase or decrease your average monthly net income calculation. You can upload payroll or bank documents instead, and you can still add documents after connecting.',
    actionRelinkWarning:
      'Note: Re-linking the same institution replaces its current payroll data with up-to-date info.',
  },
} as const;
